import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import { FaStar } from 'react-icons/fa';

// Import images
import Image1 from '../../../../Data/img/mehendi/all.png';
import Image2 from '../../../../Data/img/mehendi/arabicnew.jpg';
import Image3 from '../../../../Data/img/mehendi/bri1.jpg';
import Image4 from '../../../../Data/img/mehendi/carwa1.png';
import Image5 from '../../../../Data/img/mehendi/heavybri1.png';

const reviews = [
  {
    img: Image1,
    name: 'John Doe',
    review: 'Excellent service! Highly recommend for anyone looking for professional and reliable service.',
    rating: 5
  },
  {
    img: Image2,
    name: 'Jane Smith',
    review: 'Great experience. The team was very attentive and delivered high-quality work.',
    rating: 4
  },
  {
    img: Image3,
    name: 'Alice Johnson',
    review: 'I am very pleased with the outcome. The attention to detail was remarkable.',
    rating: 5
  },
  {
    img: Image4,
    name: 'Bob Brown',
    review: 'The service was good, but I felt there were areas for improvement in communication.',
    rating: 3
  },
  {
    img: Image5,
    name: 'Charlie Davis',
    review: 'Outstanding work! The final result exceeded my expectations.',
    rating: 5
  }
];

const ReviewSlider = () => {
  return (
    <div className="flex flex-col items-center py-10 px-4 bg-gray-100  ">
      <div className="relative w-full max-w-screen-xl  mx-auto mt-6 ">
        <Swiper
          spaceBetween={20}
          slidesPerView={1} // Default for mobile
          navigation={true}
          loop={true}
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          breakpoints={{
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
          className="mySwiper"
        >
          {reviews.map((review, index) => (
            <SwiperSlide key={index} className=" flex flex-col items-center bg-gradient-to-br from-white to-gray-50 p-4 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:scale-105">
              <div className=" bg-gradient-to-br from-yellow-200 to-purple-500 p-2 rounded-full shadow-lg">
                <img
                  src={review.img}
                  alt={review.name}
                  className="w-24 h-24 object-cover rounded-full border-4 border-white"
                />
              </div>
              <div className="pt-12 pb-4 text-center">
                <h2 className="text-lg font-semibold mb-2">{review.name}</h2>
                <div className="flex justify-center mb-2">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className={`text-yellow-500 ${i < review.rating ? 'fill-current' : 'text-gray-300'}`} />
                  ))}
                </div>
                <p className="text-gray-700 ">{review.review}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default ReviewSlider;
